import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=10935350&scoped=true"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"
import style0 from "./RatingStar.vue?vue&type=style&index=0&id=10935350&prod&scoped=true&lang=css"
import style1 from "./RatingStar.vue?vue&type=style&index=1&id=10935350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10935350",
  null
  
)

export default component.exports